export default __webpack_public_path__ + "static/media/processing_report_KADAP.ccf0eb13.pdf";